import axios from 'axios';
import { getMasterAgentApiBase } from '@/lib/reportHtml';
import { formatApiError } from '@/lib/vibeChatApi';

/**
 * POST /abap/deploy — deploy ABAP source to SAP via the Halo Master Agent (:8080).
 * Chat uses gateway → aistudioapi; deploy uses orchestrator directly.
 */
export async function deployAbapCode({
  code,
  objectName,
  description = '',
  objectType = 'PROG',
  packageName = '$TMP',
}) {
  const apiBase = getMasterAgentApiBase();
  if (!apiBase) {
    throw new Error(
      'Master agent URL is not configured (set REACT_APP_ORCHESTRATOR_URL, e.g. http://localhost:8080)',
    );
  }

  const response = await axios.post(`${apiBase}/abap/deploy`, {
    code,
    object_name: objectName,
    object_type: objectType,
    description,
    package: packageName,
  });
  return response.data;
}

export { formatApiError };
